export default "/kiban/_next/static/images/procurement-1fad1d70bfbde1762aefd9cb8dd8f52d.png";